import { callIcon, cardsStack, domainIcon, mailIcon } from '../../assets/hostedassets';
import type { DirectorKnownValues, KnownDetailsScope, KnownDetailType } from './types';

export const ALL_KNOWN_DETAILS_DRAWER_PARAM = 'allKnownDetails';

export const ALL_KNOWN_DETAILS_TITLE = 'All Known Details';

export const ALL_KNOWN_DETAILS_DRAWER_WIDTH = '39.1875rem';

export const KNOWN_DETAIL_TAB_ORDER: KnownDetailType[] = ['NAME', 'ADDRESS', 'EMAIL', 'PHONE'];

export const KNOWN_DETAIL_CARD_ORDER: KnownDetailType[] = ['NAME', 'ADDRESS', 'PHONE', 'EMAIL'];

export const DIRECTOR_KNOWN_VALUES_KEY: Record<KnownDetailType, keyof DirectorKnownValues> = {
    NAME: 'name',
    ADDRESS: 'address',
    EMAIL: 'email',
    PHONE: 'phone',
};

export const KNOWN_DETAIL_TAB_LABEL: Record<KnownDetailType, string> = {
    NAME: 'Names',
    ADDRESS: 'Addresses',
    EMAIL: 'Emails',
    PHONE: 'Contacts',
};

export const KNOWN_DETAIL_NOUN: Record<KnownDetailType, { singular: string; plural: string }> = {
    NAME: { singular: 'Name', plural: 'Names' },
    ADDRESS: { singular: 'Address', plural: 'Addresses' },
    EMAIL: { singular: 'Email', plural: 'Emails' },
    PHONE: { singular: 'Contact', plural: 'Contacts' },
};

export const KNOWN_DETAIL_ROW_ICON: Record<KnownDetailType, string> = {
    NAME: cardsStack,
    ADDRESS: domainIcon,
    PHONE: callIcon,
    EMAIL: mailIcon,
};

/** Marks each value line. Only these two types have a meaningful glyph; the rest fall back to the bullet. */
export const KNOWN_VALUE_GLYPH_ICON: Partial<Record<KnownDetailType, string>> = {
    EMAIL: mailIcon,
    PHONE: callIcon,
};

export const KNOWN_VALUE_BULLET = '•';

export const META_SEPARATOR_DOT = '•';

export const MANUAL_SOURCE_ID = 'MANUAL';

export const DIRECTORS_ROW_LABEL = 'Directors';

export const DIRECTORS_SCOPE: KnownDetailsScope = 'DIRECTORS';

export const EDIT_PROFILE_SUB_LABEL = '(in Edit Profile)';
export const EDIT_DETAILS_SUB_LABEL = '(in Edit Details)';

export const EMPTY_TAB_COPY: Record<KnownDetailType, string> = {
    NAME: 'No Names found from any source.',
    ADDRESS: 'No Addresses found from any source.',
    EMAIL: 'No Emails found from any source.',
    PHONE: 'No Contacts found from any source.',
};

export const MORE_VALUES_SHEET_HEADING: Record<KnownDetailType, string> = {
    NAME: 'All known names',
    ADDRESS: 'All known addresses',
    EMAIL: 'All known emails',
    PHONE: 'All known phones',
};

export const MASKED_SOURCE_HINT = 'Partially hidden by the source.';

export const EMPTY_VALUE_PLACEHOLDER = '-';

export const MORE_VALUES_HIDE_DELAY_MS = 500;

export const ALL_KNOWN_DETAILS_TESTIDS = {
    CARD: 'all-known-details-card',
    CARD_ROW: 'all-known-details-card-row',
    VIEW_ALL: 'all-known-details-view-all',
    MORE_TRIGGER: 'all-known-details-more-trigger',
    DRAWER: 'all-known-details-drawer',
    TAB_BAR: 'all-known-details-tab-bar',
    TAB: 'all-known-details-tab',
    TAB_PANEL: 'all-known-details-tab-panel',
    ENTITY: 'all-known-details-entity',
    ENTITY_PILL: 'all-known-details-entity-pill',
    SOURCE_ROW: 'all-known-details-source-row',
    SOURCE_CLUSTER: 'all-known-details-source-cluster',
    SOURCE_CLUSTER_HEADER: 'all-known-details-source-cluster-header',
    VALUE_LIST: 'all-known-details-value-list',
    SOURCE_ATTRIBUTION: 'all-known-details-source-attribution',
    VALUE: 'all-known-details-value',
    GLYPH: 'all-known-details-glyph',
    EMPTY_TAB: 'all-known-details-empty-tab',
} as const;

export const KNOWN_DETAILS_PANEL_ID = 'all-known-details-panel';
